<div class="loading-container" *ngIf="isLoading">
    <div class="spinner"></div>
    <p>Carregando dados...</p>
</div>

<div class="main-container" *ngIf="!isLoading && !toggle">
    <div class="close-background" (click)="onToggleClick($event)"></div>
    <div class="table-container" (click)="$event.stopPropagation()">
        <div class="table-header">
            <h2 class="title">REGISTROS FISCO</h2>
        </div>

        <div class="division"></div>
        <div class="scrollable-table">

            <table class="table">
                <thead>
                    <tr>
                        <th>REGISTRO</th>
                        <th>EMPRESA</th>
                        <th>FORNECEDOR</th>
                        <th>PLACA</th>
                        <th>ENTRADA</th>
                        <th>AÇÃO</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let data of data$ | async">
                        <td>{{data.sequencia}}</td>
                        <td>{{data.fornecedor}} </td>
                        <td>{{data.descricaoTipoVeiculo}}</td>
                        <td>{{data.placaVeiculo}}</td>
                        <td>{{data.entrada | date:'dd/MM/yyyy HH:mm'}}</td>
                        <td>
                            <div class="actions">
                                <button class="link" (click)="onSelectRow(data, $event)">
                                    <fa-icon [icon]="faCheck"></fa-icon>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>